<template>
    <div class="dark h-screen w-screen bg-gradient-to-br from-gray-700 to-gray-900">
        <slot />
    </div>
</template>